// Scroll to section
$('.js-scroll-to').on('click', function () {
  const positionTop = $('.js-scroll-target').offset().top - 30;
  $('html, body').animate({
    scrollTop: positionTop
  }, 800);
});